import React, { useEffect } from "react"
import { Box, Dialog, DialogContent, styled, Typography, IconButton } from "@mui/material"
import AppButton from "components/StyledComponents/AppButton"
import AppTextField from "components/StyledComponents/AppTextField"
import { Formik } from "formik"
import { validationSchemaCategoryModal } from "helpers/validationSchema"
import CloseIcon from "@mui/icons-material/Close"
import { useTheme } from "@mui/system"
import { addMenuCategoryAction } from "redux/superAdmin/actions"
import { useDispatch, useSelector } from "react-redux"
import {
  editMenuCategoryDetailsAction,
  getMenuCategoryDetailsAction
} from "redux/superAdmin/actions/user"

const buttonText = {
  CANCEL: "Cancel",
  SAVE: "Save",
  UPDATE: "Update"
}

const StyledDialog = styled(Dialog)(({ theme }) => ({
  "& .MuiPaper-root": {
    backgroundColor: "transparent"
  },
  "& .MuiDialogContent-root": {
    backgroundColor: theme.palette.background.default,
    borderRadius: 12,
    border: "none",
    width: 580,
    padding: 35,
    boxSizing: "border-box"
  }
}))

function CategoryModal({ open = false, onClose = () => {}, isEdit = false, selectedMenuId }) {
  const theme = useTheme()
  const { menuCategoryDetails } = useSelector((store) => store?.superAdmin)

  const dispatch = useDispatch()

  const styles = {
    closeBtn: {
      color: theme.palette.text.primary,
      position: "absolute",
      top: "10px",
      right: "10px",
      backgroundColor: theme.palette.background.main
    }
  }

  function handleButton(formik, btnValue) {
    if (btnValue?.trim() === buttonText.CANCEL) {
      onClose()
    } else if (btnValue?.trim() === buttonText.SAVE) {
      const payload = {
        menu_categories: [
          {
            name: formik.values?.category ?? ""
          }
        ]
      }
      dispatch(addMenuCategoryAction({ payload, onClose }))
    }
  }

  function handleEdit(formik, btnValue) {
    if (btnValue?.trim() === buttonText.CANCEL) {
      onClose()
    } else if (btnValue?.trim() === buttonText.UPDATE) {
      const payload = {
        name: formik.values?.category ?? ""
      }
      dispatch(editMenuCategoryDetailsAction({ payload, onClose, id: selectedMenuId }))
    }
  }

  useEffect(() => {
    if (isEdit) dispatch(getMenuCategoryDetailsAction(selectedMenuId))
  }, [open])

  return (
    <StyledDialog open={open}>
      <DialogContent>
        <Box className="d-flex justify-content-end">
          <IconButton onClick={() => onClose()} sx={styles.closeBtn}>
            <CloseIcon sx={{ height: "14px", width: "14px" }} />
          </IconButton>
        </Box>
        <Box className="w-100 d-flex justify-content-center mb-2">
          <Typography variant="h2">
            {isEdit ? "Edit Menu Category" : "Add New Menu Category"}
          </Typography>
        </Box>
        <Formik
          initialValues={
            isEdit
              ? {
                  category: menuCategoryDetails ? menuCategoryDetails?.name : ""
                }
              : {
                  category: ""
                }
          }
          enableReinitialize={true}
          onSubmit={isEdit ? handleEdit : handleButton}
          validationSchema={validationSchemaCategoryModal}>
          {(formik) => (
            <>
              <Box flexDirection="column" className="mt-4">
                <React.Fragment>
                  <Box className="d-flex justify-content-between w-100 py-2">
                    <AppTextField
                      id="category"
                      name="category"
                      fullWidth
                      isUpperCase={!false}
                      label={`Category`}
                      isRequired={true}
                      placeholder="Enter Category"
                      value={formik.values.category}
                      onChange={formik.handleChange}
                      error={formik.touched.category && Boolean(formik.errors.category)}
                      helperText={formik.errors.category}
                    />
                  </Box>
                </React.Fragment>
              </Box>
              <Box className="mt-5 d-flex justify-content-around">
                <AppButton
                  disabled={
                    Boolean(formik?.errors.category) || formik?.values.category?.length === 0
                  }
                  onClick={(e) =>
                    isEdit
                      ? handleEdit(formik, e.target.innerText)
                      : handleButton(formik, e.target.innerText)
                  }
                  sx={{ height: "48px", width: 150 }}
                  variant="outlined">
                  {isEdit ? buttonText.UPDATE : buttonText.SAVE}
                </AppButton>
                <AppButton
                  onClick={(e) => handleButton(formik, e.target.innerText)}
                  sx={{ height: "48px", width: 150 }}
                  variant="outlined">
                  {buttonText.CANCEL}
                </AppButton>
              </Box>
            </>
          )}
        </Formik>
      </DialogContent>
    </StyledDialog>
  )
}

export default CategoryModal
